import { styled } from "sharedUI/styles";
import { css } from "styled-components";
import { RoundedRect } from "../orgs-styles";

interface Props {
    background: string;
    menuOpen: boolean;
    isSelected: boolean;
    canHover: boolean;
    hasActions?: boolean;
}

const openProps = css`
    opacity: 1;
    pointer-events: auto;
`;

export const AppTileStyle = styled(RoundedRect)<Props>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background-color: ${p => p.theme.dashboard.bgCard};
    border: 0;
    box-shadow: ${p => p.theme.shadow0};
    transition: all ${p => p.theme.transitionBase};
    cursor: pointer;

    &.dim {
        background-color: ${p => p.theme.dashboard.bgCard}7A;
    }

    &:before {
        content: "";
        display: inline-block;
        width: 1px;
        height: 0;
        padding-bottom: calc(90%);
    }

    :hover,
    :focus {
        background-color: ${p => p.theme.dashboard.bgCardHover};
        box-shadow: ${p => p.theme.shadow4};
        transform: translateY(-3px);

        .hats-menu {
            ${p => p.canHover && openProps}
        }

        .star-off {
            opacity: 1;
        }
    }

    .star-off {
        opacity: 0;
    }

    .hats-menu {
        display: inline-flex;
        position: absolute;
        top: 6px;
        right: 6px;
        opacity: 0;
        color: ${p => p.theme.fgColorMedium};
        transition: all ${p => p.theme.transitionBase};
    }

    .hats-menu > * {
        width: 28px;
        height: 28px;
        padding: 4px;
        border-radius: 6px;
        transition: background-color ${p => p.theme.transitionBase};

        &:hover {
            color: ${p => p.theme.iconDark};
            background: ${p => p.theme.n200A};
        }
    }

    .app-tile-upper-left {
        position: absolute;
        top: 8px;
        left: 8px;
        display: flex;
    }

    .hats-badge {
        background-color: ${p => p.theme.n300A};
        color: ${p => p.theme.textInverse};
        margin-right: 4px;
        &.badge-basic {
            background-color: ${p => p.theme.g200};
            color: ${p => p.theme.g500};
        }

        &.badge-pro {
            background-color: ${p => p.theme.b200};
            color: ${p => p.theme.b500};
        }
    }

    &.disabled {
        pointer-events: none;
        opacity: 0.4;
    }

    & .atile-content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    & .atile-enter {
        opacity: 0;
    }

    & .atile-enter-active {
        opacity: 1;
        transition: opacity 250ms;
    }

    & .atile-bottom-bar {
        margin-top: 16px;
        padding: 0 16px;
        display: grid;
        grid-template-areas:
            "title price"
            "caption .";
        grid-template-columns: auto min-content;
        grid-template-rows: auto min-content;
    }

    & .atile-overflow-wrapper {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    & .atile-left-column {
        display: flex;
        align-items: center;
        overflow: hidden;
    }

    & .atile-name {
        grid-area: title;
        justify-content: center;
        font-size: 14px;
    }

    & .atile-caption {
        grid-area: caption;
        justify-content: center;
        font-size: 11px;
        margin-top: 2px;
        color: ${p => p.theme.textXpale};
    }

    .new-app-icon {
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 56px;
        height: 56px;
        border-radius: 12px;
        color: ${p => p.theme.iconInverse};
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            background-color: ${p => p.theme.accentInverse};
            transition: transform ${p => p.theme.transitionBase};
            transition-duration: 250ms;
            transition-timing-function: cubic-bezier(0, 0.7, 0.5, 1);
            will-change: transform;
        }

        svg path {
            stroke-width: 2;
        }
    }

    &:hover .new-app-icon:before {
        transform: scale(1.14);
        transition-duration: 125ms;
    }
`;
